import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Form, Input, Button } from 'antd'
import { successMessage, errorMessage, assignMessage } from '../../utils/helpers'
import { removeUser } from '../../Redux/actions/authActions'
import { AUTH } from '../../utils/apis'
import { allPaths } from '../../utils/constants'
import { LoginHeader } from '../../Components'
import axios from 'axios'
import WGP_logo_Text from '../../assets/WGP-white.png'

const ForgotPassword = (props) => {
    const { language, selectedLanguage } = props
    const { history } = props
    const dispatch = useDispatch()
    const isEnglish = language?.language === 'english'
    const [loading, setLoading] = useState(false)
    const [btnText, setBtnText] = useState('Search')

    const onFinish = (values) => {
        setLoading(true)
        setBtnText('Searching...')

        values.userType = 'player'

        axios.post(AUTH.FORGOT_PASSWORD, values)
            .then((result) => {
                const { data } = result
                setLoading(false)
                setBtnText('Search')
                if (data.success) {
                    return successMessage(assignMessage(data.message, language?.language))
                }
                else {
                    errorMessage(assignMessage(data.message, language?.language))
                }
            })
            .catch((err) => {
                setLoading(false)
                setBtnText('Search')
                errorMessage(assignMessage(err.message, language?.language))
            })
    }

    useEffect(() => {
        dispatch(removeUser())
    }, [])

    return (
        <div>
            <LoginHeader />
            <div className='auth-screen-main-div-new sidebar-scroll_class'>
                <center>
                    <img src={WGP_logo_Text} className='img-for-login-page' />
                </center>
                <p className='heading head-center' style={{ color: 'white' }}>
                    {selectedLanguage?.title_ResetPassword}
                </p>
                <Form
                    name='form'
                    onFinish={onFinish}
                    layout={'vertical'}
                    requiredMark={false}
                >
                    <div className='form-input-single-input'>
                        <Form.Item
                            name='email'
                            label={<p className='p-admin-title-text'>{selectedLanguage?.label_Email}</p>}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: selectedLanguage?.error_PleaseEnterYourEmail,
                                },
                                {
                                    type: 'email',
                                    message: selectedLanguage?.error_EmailIsNotValid,
                                },
                            ]}
                        >
                            <Input
                                className='form-input-new-design-big-slam'
                                placeholder={selectedLanguage?.placeHolder_PleaseEnterYourEmail}
                            />
                        </Form.Item>
                    </div>
                    <Form.Item>
                        <Button
                            className='login-btn-height'
                            type='primary'
                            block
                            htmlType='submit'
                            loading={loading}
                        >
                            {btnText === 'Search' ? selectedLanguage?.ButtonText_Search : selectedLanguage?.ButtonText_Searching}
                        </Button>
                        <br />
                        <br />
                        <div style={{ textAlign: 'center', marginTop: '20px', color: 'white' }}>
                            {selectedLanguage?.minTitle_AlreadyHaveAnAccount} <Link className='linkStyle' to={allPaths?.LOGIN}>{selectedLanguage?.minTitle_Login}</Link>
                            <br />
                            {selectedLanguage?.minTitle_DontHaveAnAccount} <Link className='linkStyle' to={allPaths?.SIGNUP}>{selectedLanguage?.minTitle_SignUp}</Link>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </div>
    )
}

export default ForgotPassword